export const containerVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.1,
      ease: "easeOut",
      when: "beforeChildren",
      staggerChildren: 0.1,
    },
  },
};

export const itemVariants = {
  hidden: { 
    opacity: 0, 
    y: 5, // Reduced initial y-offset for smoother entry
    transition: { duration: 0.1 } 
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: { 
      duration: 0.2, // Slightly longer duration for smoother appearance
      ease: "easeOut" 
    }
  }
};

export const dropdownVariants = {
  hidden: { 
    opacity: 0, 
    y: -10, 
    height: 0,
    transition: { 
      duration: 0.1,
      when: "afterChildren" // Wait for children to hide first
    } 
  },
  visible: {
    opacity: 1,
    y: 0,
    height: "auto",
    transition: { 
      duration: 0.3, 
      ease: "easeOut",
      when: "beforeChildren", // Animate container before children
      staggerChildren: 0.05 // Reduced stagger for quicker appearance
    }
  },
  exit: { 
    opacity: 0, 
    y: -10, 
    height: 0,
    transition: {
      duration: 0.2,
      when: "afterChildren" // Hide container after children
    }
  }
};

export const sectionVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  transition: { duration: 0.1 },
};

export const headingVariants = {
  initial: { x: -20, opacity: 0 },
  animate: { x: 0, opacity: 1 },
  transition: { duration: 0.3 },
};

export const inputAnimations = {
  whileFocus: { 
    scale: 1.01,
    transition: { duration: 0.3, ease: "easeOut" } 
  },
  whileHover: { 
    scale: 1.01,
    transition: { duration: 0.3, ease: "easeOut" } 
  },
};

export const buttonAnimations = {
  whileHover: {
    scale: 1.01,
    y: -2,
    transition: {
      duration: 0.2,
      ease: "easeOut",
    },
  },
  whileTap: {
    scale: 0.98,
    y: 0,
    transition: {
      duration: 0.1,
      ease: "easeOut",
    },
  },
};

export const loadingButtonAnimations = {
  whileHover: { scale: 1.02 },
  whileTap: { scale: 0.98 },
};

export const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
      ease: [0.22, 1, 0.36, 1],
      bounce: 0.4,
    },
  },
};

export const dialogVariants = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 300,
      damping: 20,
    },
  },
  exit: { opacity: 0, scale: 0.9 },
};